module.exports = __webpack_public_path__ + "img/source_sw-item6.19c62edc.png";